// extracted by mini-css-extract-plugin
export var infoRow = "_v1-2";
export var labelContainer = "_v1-0";
export var rightInfo = "_v1-1";